import React from 'react';
import StockItemsPage from 'pages/shared/inventory-stock/stock-items-page';

const KitchenInventoryStockItems = () => {
  return <StockItemsPage defaultStoreType='kitchen-store' />;
};

export default KitchenInventoryStockItems;
